import React from "react";
import { IoTicketOutline } from "react-icons/io5";
import EAButton from "../../shared/Buttons/EAButton";

const BuyTicketsButton: React.FC = () => {
  const handleClick = () => {
    window.open("https://www.kortosfera.uwm.edu.pl/kup-bilet/", "_blank", "noopener,noreferrer");
  };
  return <EAButton title="Kup bilety" onClick={handleClick} startIcon={<IoTicketOutline />} />;
};

export default BuyTicketsButton;
